import { getQueryParam } from '@ahoy/aquarium/dist/utils/getQueryParam';

export function isAdditionalInsuredMtaRoute(): boolean {
  return getQueryParam('additionalInsuredMta') === '1';
}
